module.exports = __webpack_public_path__ + "img/cloud-drizzle.b0ac0b78.svg";